

export default function basicNavigation() {

    const $navbarSearchToggle = $('.toggle-search');
    const $navbarSearch = $('.navbar-search');


    $navbarSearchToggle.on('click', function(e){
        e.preventDefault();
        $('body').toggleClass("show-search");
        setTimeout(()=>($navbarSearch.find('input[type=search]').focus()), 450);
    });

    $('.topnav-search input').focus(function() {
        $('.topnav-search i').addClass('d-none');
    });

    $('.topnav-search input').focusout(function() {
        if($('.topnav-search input').val() > 0) {
            $('.topnav-search i').addClass('d-none');
        } else {
            $('.topnav-search i').removeClass('d-none');
        }
    });
}
